import * as React from "react";
import { Button } from "react-ui";

import { Message, Root } from "./MessageBox.styles";
import { MessageBoxType } from "./MessageBoxType";

export interface MessageBoxProps {
    type: MessageBoxType;
    onGetExpertErrorLog: () => void;
    children: React.ReactNode;
}

export function MessageBox(props: MessageBoxProps): JSX.Element {
    switch (props.type) {
        case MessageBoxType.errorLog:
            return (
                <Root type={props.type}>
                    <div>{props.children}</div>
                    <Message>Исправьте ошибки, чтобы сформировать финансовый анализ.</Message>
                </Root>
            );

        case MessageBoxType.error:
            return (
                <Root type={props.type}>
                    Не удалось запустить проверку для формирования финансового анализа,{" "}
                    <Button use="link" onClick={props.onGetExpertErrorLog}>
                        попробуйте снова
                    </Button>
                    .
                </Root>
            );

        case MessageBoxType.success:
            return (
                <Root type={props.type}>
                    <div>{props.children}</div>
                    <Message>Ошибок и предупреждений нет.</Message>
                </Root>
            );

        default:
            return <div />;
    }
}
